import { isIOSDevice } from '@/utils';
import { openBrowser, windowOpen } from './base';
import { isForeignEnvironment, isPhonepe, isThirdPartyClient } from './client';

export function downloadDoc(url: string, fileName?: string) {
	const link = document.createElement('a');
	link.href = url;
	link.download = fileName ? `${fileName}` : 'file.pdf';
	link.target = '_blank';
	link.dispatchEvent(new MouseEvent('click'));
}

export function downloadPdfDocument(url: string, fileName?: string): void {
	const isForeignEnv = isForeignEnvironment() || isThirdPartyClient();
	if (!isIOSDevice() && isPhonepe()) {
		// Call download doc for Phonepe Android Users
		downloadDoc(url, fileName);
	} else if (isForeignEnv) {
		const isSupported = openBrowser(url);
		if (!isSupported) {
			windowOpen(`https://docs.google.com/viewer?url=${url}`);
		}
	} else {
		downloadDoc(url, fileName);
	}
}
